import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export function selectorIsSharedFileCOIContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return (
    !!contextType &&
    (contextType ===
      SharedFileRequestContextType.WorkersCompCertificateOfInsurance ||
      contextType ===
        SharedFileRequestContextType.GeneralLiabilityCertificateOfInsurance)
  );
}
